<div class="doc-details">
  <div class="row px-3">
    <div class="col-md-12">
      <span class="details-label"
        >{{ moduleTranslationPrifix + 'Document-Name' | translate }} :</span
      >
      <span class="details-info"
        >{{ currentLanguage === 'en' ? documentDetails?.name :
        documentDetails?.nameAr }}</span
      >
    </div>

    <div class="col-lg-5 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Issuer-Name'| translate}} :
      </span>
      <span class="details-info"
        >{{currentLanguage === 'en' ? documentDetails?.issuerName :
        documentDetails?.issuerNameAr }}</span
      >
    </div>
    <div class="col-lg-7 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Entity-Functions'| translate}} :
      </span>
      <span class="details-info">{{documentDetails?.functions}}</span>
    </div>
    <div class="col-lg-5 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Document-Owner'| translate}} :
      </span>
      <span class="details-info">{{documentDetails?.owners}}</span>
    </div>
    <div class="col-lg-7 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Version'| translate}} :
      </span>
      <span class="details-info">{{documentDetails?.version}}</span>
    </div>
    <div class="col-lg-5 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Reference-Number'| translate}} :
      </span>
      <span class="details-info">{{ documentDetails?.referenceNumber }}</span>
    </div>
    <div class="col-lg-7 col-md-12 mt-3">
      <span class="details-label"
        >{{moduleTranslationPrifix + 'Effective-Date'| translate}} :
      </span>
      <span class="details-info">
        {{ documentDetails?.effectiveDate ? (documentDetails?.effectiveDate |
        date : (currentLanguage === "ar" ? "yyyy/MM/dd" : "dd/MM/yyyy")) : "-"
        }}
      </span>
    </div>
    @if(viewApprovment ){
    <div class="col-md-12 mt-3">
      <span class="details-label"
        >{{'Document-Approvements.Approval-Status' | translate}} :
      </span>
      <span class="status-wrapper status-{{documentDetails?.status?.id}}">
        {{ documentDetails?.status?.name }}
      </span>
    </div>
    }

    <div class="col-md-12 mt-3">
      <p class="details-label">{{'Description'| translate}} :</p>
      <span class="details-info">{{ documentDetails?.description }}</span>
    </div>
    <div class="table my-3">
      <!-- Content -->

      @if(isContentView){
      <span class="content-title"
        >{{ moduleTranslationPrifix + 'Content' | translate}}</span
      >
      <div class="content-table row mx-1 pb-3">
        <div class="filters-wrapper">
          <div class="search-wrapper d-flex align-items-center px-0">
            @if(originalTree.length > 0){
            <img
              class="mx-2"
              src="../../../../../../../assets/images/icons/search.svg"
              alt="" />
            <input
              class="px-2 m-2 search-input"
              type="search"
              placeholder="{{ 'Search-By-Name' | translate }}"
              [(ngModel)]="searchVal"
              (ngModelChange)="onSearch($event)" />
            }
          </div>
        </div>
        <!-- Tree -->
        <p-tree
          [value]="contentList"
          dragdropScope="myScope"
          emptyMessage="{{ 'No-Results-Found' | translate}}"
          class="custom-tree px-0">
          <ng-template let-node pTemplate="default">
            <div class="tree-node-row mx-0" [ngClass]="getNodeClass(node)">
              <div class="row">
                <div class="col-md-12 py-2">
                  <div class="d-flex align-items-center">
                    <!--  Drag and Expand Icon -->
                    <div class="expand-icon">
                      <!-- <span class="drag-handle">
                                <i class="bi bi-grip-vertical mx-2"></i>
                              </span> -->

                      <img
                        alt=""
                        [style.visibility]="node?.children?.length > 0 ? 'visible' : 'hidden'"
                        [style.transform]="node.expanded ? 'rotate(180deg)' : 'rotate(0deg)'"
                        (click)="node.expanded = !node.expanded"
                        src="../../../../../assets/images/icons/arrow-down.svg"
                        alt="" />
                    </div>

                    <!-- Rows -->
                    <div
                      class="row w-100"
                      (click)="node.expanded = !node.expanded">
                      <div class="col-md-8">
                        <p class="label">{{ node.content |htmlToText}}</p>
                      </div>
                      <div class="col-md-4">
                        @for (event of node?.events; track event ; let last =
                        $last) {
                        <span class="meta-info">{{ event?.name}}</span>
                        @if(!last){
                        <span>,</span>
                        } }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-tree>
      </div>
      } @if(viewApprovment){
      <div class="col-12 mt-3 text-center">
        <a class="link-btn" (click)="showHideContent()">
          @if(isContentView){
          <span class="px-0"
            >{{ moduleTranslationPrifix + 'Show-Less' | translate}}</span
          >
          <i class="bi bi-chevron-down"></i>
          }@else{
          <span>{{ moduleTranslationPrifix + 'Show-More' | translate}}</span>
          <i class="bi bi-chevron-up"></i>

          }
        </a>
      </div>
      }
    </div>

    <!-- Attachments -->
    <div class="col-12 mt-3">
      <span class="details-label"
        >{{ moduleTranslationPrifix + 'Attachments' | translate }}</span
      >
      <div class="attach-list mt-2">
        @if(documentDetails?.attachments.length >0){ @for (item of
        documentDetails?.attachments; track item) {
        <div>
          <i class="bi bi-paperclip attchment-icon"></i>
          <span class="attach-name cursor-pointer" (click)="downLoadFile(item)">
            {{ (item).split('hema/').pop() }}
          </span>
        </div>
        } }@else{
        <span class="attach-name cursor-pointer">
          {{"Common-Msg.No-Attachments-Found" | translate}}
        </span>
        }
      </div>
    </div>

    @if (showAcknowledge) {
    <div class="d-flex justify-content-end mt-4 px-3">
      <button class="primary" type="button" (click)="onSubmit()">
        <span>{{ moduleTranslationPrifix + "Acknowledge" | translate }}</span>
      </button>
    </div>
    }
  </div>
</div>
